import { useEffect, useRef, useState, useMemo } from "react";
import { useThumbnailCache } from "../../../contexts/ThumbnailContext";
import { Workspace } from "polotno/canvas/workspace";
import "./Export.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import {
    canUserDownloadImage,
    doRequest,
    downloadFile,
    isPlanExpired,
} from "../../../utils/helper";
import { config } from "../../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import VariationCountLabel from "../../../components/VariationCountLabel";
import Sidebar from "../../../components/Sidebar";
import { Button } from "reactstrap";
import { setTshirtDetails } from "../../../redux/slices/variationSlice";
import { getPlanDetails, setAllData } from "../../../redux/slices/PlanDetailSlice";
import { setUserData } from "../../../redux/slices/UserSlice";
import { toast } from "react-toastify";
import Skeleton from "./Skeleton";
import {
    renderPolotnoDesign,
    clearExportJobs,
} from "../../../redux/slices/PolotnoSlice";
import {
    downloadBatchAsZip,
    exportBatchFiles,
    exportSingleFile,
    getQualityForFormat,
    validateExportOptions,
} from "./CloudRenderExport";
import DownloadCancelPopup from "../../../components/DownloadCancelPopup";
import { showToast } from "../../../redux/slices/ToastSlice";
import useDesignData from "../../../hook/useDesignData";
import { useFontLoader } from "../../../hook/useFontLoader";

import { unstable_setTextOverflow } from "polotno/config";
import { BeatLoader } from "react-spinners";
import {
    SearchX,
    Settings,
    ChevronDown,
    Download,
    Image,
    X,
    Search,
} from "lucide-react";

// component
import BackButton from "../../../components/ui/backButton";
import ThumbnailCard from "../../../components/export/ThumbnailCard";
import ErrorMessage from "../../../components/export/Error";
// APIs
import {
    postProccessBulkImages,
    checkProcessingStatus,
} from "../../../services/APIs/imageProcessing";
//utils
import useDebounce from "../../../hook/useDebounce";
import LoadingMessage from "../../../components/export/Loading";
import { isPaperSizeType } from "../../../utils/helper";
import { changeDpiDataUrl } from "changedpi";
import JSZip from "jszip";
import { setDownScalingEnabled } from "polotno/utils/flags";
import InternetSpeedIndicator from "../../../components/InternetSpeedIndicator";
import { trackAnalyticsEvent } from "../../../utils/analytics";

import { FastAverageColor } from "fast-average-color";


const allFormats = [
    { type: "jpeg", text: "Best of sharing" },
    { type: "png", text: "Best of sharing" },
    { type: "pdf", text: "Best of sharing" },
];

const dpis = [
    {
        type: "72",
        text: "72 DPI",
    },
    {
        type: "300",
        text: "300 DPI",
    },
];

    const fac = new FastAverageColor();
// constants
const BLOB_QUALITY = 0.1;
const BATCH_SIZE = 1;
const PRIORITY_COUNT = 15;

const runFakeProgress = (setPercentDownloaded, onFinish) => {
    let percent = 0;
  
    const interval = setInterval(() => {
      percent += Math.random() * 8 + 5; 
  
      if (percent >= 90) {
        percent = 90;
      }
  
      setPercentDownloaded(Math.round(percent));
    }, 1000);
  
    return () => {
      clearInterval(interval);
      setPercentDownloaded(100);
  
      setTimeout(() => {
        onFinish && onFinish();
      }, 500);
    };
  };

  
  // Helper: pure base64 + mime → Blob
  const base64ToBlob = (pureBase64, mimeType) => {
    const byteString = atob(pureBase64);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
  };

  
export default function ExportOptimised({ store }) {
    const { getCachedThumbnails, cacheThumbnails, updateSingleThumbnail } =
        useThumbnailCache();
    const userData = useSelector((state) => state.user.userData);
    const userExportSettings = userData?.export_settings;
    const userPlanDetails = useSelector((state) => state.userPlan);
    const sizeDimensions = useSelector(
        (state) => state.sizeDimension.dimensions
    );
    const selectedType = useSelector(
        (state) => state.sizeDimension.selectedType
    );
    const [preferenceType, setPreferenceType] = useState(false);
    const [checkedItems, setCheckedItems] = useState({
        centerMarking: userExportSettings?.centerMarking ?? true,
        edgeMarking: userExportSettings?.sizeOnBottom ?? true,
    });
    const [isPercentDownloading, setIsPercentDownloading] = useState(false);
    const [percentDownloaded, setPercentDownloaded] = useState(0);
    const [showCancelConfirm, setShowCancelConfirm] = useState(false);
    const [showDownloadDialog, setShowDownloadDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const cancelPollingRef = useRef(false);
    const { fontsJson } = useFontLoader();

    const dropdownRef = useRef(null);
    const handleCheckboxChange = (name) => {
        setCheckedItems((prev) => {
            const nextChecked = !prev[name];
            trackAnalyticsEvent("export_setting_toggle", {
                setting: name,
                enabled: nextChecked,
            });

            return {
                ...prev,
                [name]: nextChecked,
            };
        });
    };

    const { id } = useParams();
    const { designInfo } = useDesignData(store, null);

    const extractUniqueFontFamily = () => {
        const fontFamily = store.pages
            .map((page) => page.children.map((child) => child.fontFamily))
            .flat();
        const fontArr = [...new Set(fontFamily)].filter((i) => i !== undefined);
        return fontArr;
    };

    const getStoreFonts = () => {
        const fontFamily = extractUniqueFontFamily();
        const fonts = fontsJson.filter((font) =>
            fontFamily.includes(font.fontFamily)
        );
        return fonts;
    };

  
    // useEffect(() => {
    //       unstable_setTextOverflow("resize");
    //       unstable_setTextOverflow("change-font-size");
    //   }, []);
    

    useEffect(() => {
        if (!designInfo?.store_data?.store_json?.pages?.length) return;
      
        const runAutoFit = async () => {
        //   debugger
          designInfo?.store_data?.store_json?.pages.forEach((page) => {
            console.log(page)
            console.log(page?.custom?.textAutoFitEnabled, 22222)
            const isAutoFitOn =
              page.custom?.textAutoFitEnabled ?? true;
      
            //   console.log(isAutoFitOn, "is auto fit on")
            if (!isAutoFitOn) return;
      
            page.children.forEach((el) => {
                if (el.type !== "text") return;
            
                const isElementAutoFitOn =
                  el.custom?.textAutoFitEnabled ?? true;
            
                //   console.log(el, "1212", isElementAutoFitOn)
                if (!isElementAutoFitOn) return;
            
                unstable_setTextOverflow("resize");
                unstable_setTextOverflow("change-font-size");
              });
            
          });
      
          console.log("Auto-fit completed successfully!");
        };
      
        runAutoFit();
      }, [designInfo]);
      
    const options = [
        {
            name: "centerMarking",
            label: "Center Marking",
            img: "/assets/images/center-marking-icn.svg",
        },
        {
            name: "edgeMarking",
            label: "Size on bottom",
            img: "/assets/images/size-on-bottom-icn.svg",
        },
    ];
    
    const userLoginDetails = localStorage.getItem(config.USER_LOGIN_DETAILS);
    if (!userLoginDetails) {
        alert("please login first");
        navigate("/Login");
    }
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const isEdit = location?.state?.from === "edit";
    const [localThumbList, setLocalThumbList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const debouncedSearchQuery = useDebounce(searchQuery, 300);
    const tshirtDetails = useSelector((state) => state.variation.tshirtDetails);
    const [loading, setLoading] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState("jpeg");
    const [selectedDpi, setSelectedDpi] = useState("300");
    const [showFileType, setShowFileType] = useState(false);
    const [showDpi, setShowDpi] = useState(false);
    const [showWarnPopup, setShowWarnPopup] = useState(false);
    const planDetails = useSelector(
        (state) => state?.userPlan?.userPlanDetails?.[0]
    );
    const [downloadCardLoading, setDownloadCardLoading] = useState({
        index: -1,
        loading: false,
    });
    const [saveSettingsLoading, setSaveSettingsLoading] = useState(false);

    // new state added
    const [openDropdown, setOpenDropdown] = useState(null); 


    // Add this state to show the render job response
    const renderJob = useSelector((state) => state.polotno.renderJob);
    const renderLoading = useSelector((state) => state.polotno.isLoading);
    const renderError = useSelector((state) => state.polotno.error);

    useEffect(() => {
        if (localThumbList?.length === designInfo?.size_data?.sizes.length) {
            cacheThumbnails(id, localThumbList);
        }
    }, [localThumbList, id, designInfo, cacheThumbnails]);
    useEffect(() => {
        if (
            location?.state?.from === "edit" &&
            location?.state?.pageId &&
            designInfo &&
            !loading
        ) {
            // Call the new function
            regenerateSingleThumbnail(
                location?.state?.pageId,
                designInfo?.size_data?.sizes,
                location?.state?.updatedStoreJson
            );

            // Clear state to prevent re-triggering
            window.history.replaceState({}, document.title);
        }
    }, [
        location.state,
        designInfo,
        location?.state?.updatedStoreJson,
        loading,
    ]);
    // Draw canvases for each size
    useEffect(() => {
        if (
            designInfo?.size_data?.sizes?.length > 0 &&
            designInfo?.store_data?.store_json?.pages?.length > 0 &&
            localThumbList.length === 0
        ) {
            // Error handling
            if (
                !designInfo?.size_data?.sizes ||
                designInfo?.size_data?.sizes?.length === 0
            ) {
                dispatch(
                    showToast({
                        message: "No sizes available for this design",
                        type: "error",
                    })
                );
                setErrorMessage("No sizes available for this design");
                setLoading(false);
                return;
            }
            if (designInfo?.store_data?.selected_type === null) {
                dispatch(
                    showToast({
                        message: "No size type found for this design",
                        type: "error",
                    })
                );
                setErrorMessage("No size type found for this design");
                setLoading(false);
                return;
            }
            //NOTE Use cached thumbnails immediately - no regeneration needed
            const cachedThumbs = getCachedThumbnails(id);
            if (cachedThumbs) {
                setLocalThumbList(cachedThumbs);
                setLoading(false);
                return;
            }
            const tshirtSizes = designInfo?.size_data?.sizes;
            const isLoading = tshirtSizes.some((item) => item.loading);
            const isPaperSize = isPaperSizeType(
                designInfo?.store_data?.selected_type || selectedType
            );
            if (!isLoading) {
                dispatch(setTshirtDetails(tshirtSizes));
                drawCanvases(tshirtSizes, isPaperSize);
            }
        }
        if (designInfo?.design_name) {
            document.title = `${designInfo?.design_name} - Teedex`;
        }
    }, [designInfo, localThumbList.length]);

    const drawCanvases = async (tshirtSizesArr, isPaperSize) => {
        let storePages = [];
        if (designInfo?.store_data?.store_json?.pages?.length > 0) {
            storePages = designInfo?.store_data?.store_json?.pages;
        }
        if (loading) return;
        try {
            store.clear();
            setLoading(true);
            const pageIds = [];
            for (let i = 0; i < tshirtSizesArr?.length; i++) {
                if (!isPaperSize) {
                    const size = tshirtSizesArr[i]?.size;
                    const sizeId = size?.replace(/\s/g, "_");
                    const found = storePages?.find(
                        (page) => page?.id === sizeId
                    );
                    if (found) {
                        const pageCopy = structuredClone(found);
                        const playerNameChildIndex =
                            pageCopy.children?.findIndex(
                                (child) =>
                                    child.id ===
                                    `master_playernametext-${sizeId}`
                            );
                        const playerNumberChildIndex =
                            pageCopy.children?.findIndex(
                                (child) =>
                                    child.id ===
                                    `master_playernumbertext-${sizeId}`
                            );

                        if (playerNameChildIndex !== -1) {
                            const text = String(tshirtSizesArr[i].name);
                            pageCopy.children[playerNameChildIndex].text = text;

                            if (
                                pageCopy.children[playerNameChildIndex]?.custom
                                    ?.isUpperCase
                            ) {
                                pageCopy.children[playerNameChildIndex].text =
                                    text.toUpperCase();
                            } else if (
                                pageCopy.children[playerNameChildIndex]?.custom
                                    ?.isLowerCase
                            ) {
                                pageCopy.children[playerNameChildIndex].text =
                                    text.toLowerCase();
                            }

                            pageCopy.children[
                                playerNameChildIndex
                            ].id = `master_playernametext-${sizeId}-${tshirtSizesArr[i].indexSr}`;
                        }

                        if (playerNumberChildIndex !== -1) {
                            const text = tshirtSizesArr[i].number?.toString();

                            pageCopy.children[playerNumberChildIndex].text =
                                text;
                            pageCopy.children[
                                playerNumberChildIndex
                            ].id = `master_playernumbertext-${sizeId}-${tshirtSizesArr[i].indexSr}`;
                        }

                        store.addPage({
                            ...pageCopy,
                            id: String(tshirtSizesArr[i].indexSr),
                            custom: tshirtSizesArr[i],
                        });
                        pageIds.push(String(tshirtSizesArr[i].indexSr));
                    }
                } else {
                    const found = storePages?.find(
                        (page) => page?.id === "master"
                    );

                    if (!found) {
                        dispatch(
                            showToast({
                                message: "Master page not found",
                                type: "error",
                            })
                        );

                        return;
                    }
                    const pageCopy = structuredClone(found);
                    const playerNameChildIndex = pageCopy.children?.findIndex(
                        (child) => child.id === `master_playernametext`
                    );
                    const playerNumberChildIndex = pageCopy.children?.findIndex(
                        (child) => child.id === `master_playernumbertext`
                    );

                    if (playerNameChildIndex !== -1) {
                        const text = String(tshirtSizesArr[i].name);

                        pageCopy.children[playerNameChildIndex].text = text;
                        pageCopy.children[
                            playerNameChildIndex
                        ].id = `master_playernametext-${tshirtSizesArr[i].indexSr}`;
                    }

                    if (playerNumberChildIndex !== -1) {
                        const text = tshirtSizesArr[i].number?.toString();

                        pageCopy.children[playerNumberChildIndex].text = text;
                        pageCopy.children[
                            playerNumberChildIndex
                        ].id = `master_playernumbertext-${tshirtSizesArr[i].indexSr}`;
                    }

                    store.addPage({
                        ...pageCopy,
                        id: String(tshirtSizesArr[i].indexSr),
                        custom: tshirtSizesArr[i],
                    });
                    pageIds.push(String(tshirtSizesArr[i].indexSr));
                }
            }
            //NOTE -  we are drawing thumbnails in parallel batches instead of sequentially (do not mess with this code block)
            // Phase 1: Render priority thumbnails ONE BY ONE
            for (let i = 0; i < Math.min(PRIORITY_COUNT, pageIds.length); i++) {
                await drawThumByPageIdOptimized(pageIds[i], tshirtSizesArr);
            }
            // Lazy load remaining
            if (pageIds.length > PRIORITY_COUNT) {
                const remainingIds = pageIds.slice(PRIORITY_COUNT);
                requestIdleCallback(
                    (deadline) => {
                        renderRemainingThumbnails(
                            remainingIds,
                            BATCH_SIZE,
                            deadline,
                            tshirtSizesArr
                        );
                    },
                    { timeout: 2000 } // Fallback: force execution after 2 seconds
                );
            }
        } catch (error) {
            console.error("Error drawing canvases:", error);
        } finally {
            setLoading(false);
        }
    };
    const renderRemainingThumbnails = async (
        pageIds,
        batchSize,
        deadline,
        tshirtSizesArr
    ) => {
        let currentIndex = 0;

        const processBatch = async () => {
            // Process batches while there's idle time available
            while (
                currentIndex < pageIds.length &&
                deadline.timeRemaining() > 0
            ) {
                const batch = pageIds.slice(
                    currentIndex,
                    currentIndex + batchSize
                );
                await Promise.all(
                    batch.map((id) =>
                        drawThumByPageIdOptimized(id, tshirtSizesArr)
                    )
                );
                currentIndex += batchSize;
            }

            // If more work remains, schedule another idle callback
            if (currentIndex < pageIds.length) {
                requestIdleCallback(
                    (newDeadline) => {
                        renderRemainingThumbnails(
                            pageIds.slice(currentIndex),
                            batchSize,
                            newDeadline,
                            tshirtSizesArr
                        );
                    },
                    { timeout: 2000 }
                );
            }
        };

        await processBatch();
    };

    const drawThumByPageIdOptimized = async (pageId, tshirtSizesArr) => {
        const tShirtInfo = tshirtSizesArr.find(
            (item) => parseInt(item.indexSr) === parseInt(pageId)
        );
        try {

            let pixelRatio = 0.25;

            if (["a4", "a3", "a2", "a1", "custom"].includes(selectedType || designInfo?.store_data?.selected_type)) {
                pixelRatio = 0.8;
            }

            setDownScalingEnabled(false);

            const blob = await store.toDataURL({
                pageId: String(pageId),
                quality: BLOB_QUALITY,
                mimeType: "image/png",
                pixelRatio: pixelRatio,
            });
            setDownScalingEnabled(true);
            const newItem = {
                base64: blob,
                tShirtInfo: tShirtInfo,
                loading: false,
                size: tShirtInfo.size,
                indexSr: tShirtInfo.indexSr,
                name: tShirtInfo.name,
                number: tShirtInfo.number,
            };

            // Check if item already exists before adding
            setLocalThumbList((prev) => {
                // Check if this indexSr already exists in the array
                const existingIndex = prev.findIndex(
                    (item) => parseInt(item.indexSr) === parseInt(pageId)
                );

                // If exists, update it; otherwise, append
                if (existingIndex !== -1) {
                    // Update existing item
                    const newList = [...prev];
                    newList[existingIndex] = newItem;
                    return newList;
                } else {
                    // Append new item
                    return [...prev, newItem];
                }
            });
        } catch (error) {
            console.error(
                `Error rendering thumbnail for page ${pageId}:`,
                error
            );
            const newItem = {
                base64: "",
                tShirtInfo: tShirtInfo,
                loading: false,
                size: tShirtInfo.size,
                indexSr: tShirtInfo.indexSr,
                name: tShirtInfo.name,
                number: tShirtInfo.number,
            };
            setLocalThumbList((prev) => {
                // Check if this indexSr already exists in the array
                const existingIndex = prev.findIndex(
                    (item) => parseInt(item.indexSr) === parseInt(pageId)
                );

                // If exists, update it; otherwise, append
                if (existingIndex !== -1) {
                    // Update existing item
                    const newList = [...prev];
                    newList[existingIndex] = newItem;
                    return newList;
                } else {
                    // Append new item
                    return [...prev, newItem];
                }
            });
        }
    };
    // Memoized filtered list - only recalculates when dependencies change
    const filteredThumbList = useMemo(() => {
        if (!debouncedSearchQuery || debouncedSearchQuery.trim() === "") {
            return localThumbList;
        }
        const query = debouncedSearchQuery.toLowerCase().trim();
        return localThumbList.filter((item) => {
            const name = item.name?.toLowerCase() || "";
            const size = item.size?.toLowerCase() || "";
            const number = item.number?.toString().toLowerCase() || "";
            const indexSr = item.indexSr?.toString().toLowerCase() || "";
            return (
                name.includes(query) ||
                size.includes(query) ||
                number.includes(query) ||
                indexSr.includes(query)
            );
        });
    }, [localThumbList, debouncedSearchQuery]);

    useEffect(() => {
        const query = debouncedSearchQuery?.trim();
        if (!query) {
            return;
        }

        trackAnalyticsEvent("export_search", {
            query_length: query.length,
            result_count: filteredThumbList.length,
        });
    }, [debouncedSearchQuery, filteredThumbList.length]);
    const regenerateSingleThumbnail = async (
        pageId,
        tshirtSizesArr,
        updatedStoreJson = null
    ) => {
        const tShirtInfo = tshirtSizesArr.find(
            (item) => parseInt(item.indexSr) === parseInt(pageId)
        );

        if (!tShirtInfo) {
            console.error(`No tShirtInfo found for pageId: ${pageId}`);
            return;
        }

        // Set loading state (keeps old thumbnail visible)
        setLocalThumbList((prev) => {
            const existingIndex = prev.findIndex(
                (item) => parseInt(item.indexSr) === parseInt(pageId)
            );

            const loadingItem = {
                base64: prev[existingIndex]?.base64 || "",
                tShirtInfo: tShirtInfo,
                loading: true,
                size: tShirtInfo.size,
                indexSr: tShirtInfo.indexSr,
                name: tShirtInfo.name,
                number: tShirtInfo.number,
            };

            if (existingIndex !== -1) {
                const newList = [...prev];
                newList[existingIndex] = loadingItem;
                return newList;
            } else {
                return [...prev, loadingItem];
            }
        });

        try {
            // Load updated page into store if provided
            if (updatedStoreJson) {
                // Find if page exists in current store
                const existingPageIndex = store.pages.findIndex(
                    (p) => String(p.id) === String(updatedStoreJson.id)
                );

                if (existingPageIndex !== -1) {
                    // Remove the old page first
                    const existingPage = store.pages[existingPageIndex];

                    store.deletePages([existingPage.id]);

                    store.addPage({
                        ...updatedStoreJson,
                        id: String(updatedStoreJson.id),
                    });
                } else {
                    store.addPage({
                        ...updatedStoreJson,
                        id: String(updatedStoreJson.id),
                    });
                }
            }

            setDownScalingEnabled(false);
            // Generate blob
            const blob = await store.toDataURL({
                pageId: String(pageId),
                quality: BLOB_QUALITY,
                mimeType: "image/png",
                pixelRatio: 0.25,
            });
            setDownScalingEnabled(true);

            // Create new thumbnail item
            const newItem = {
                base64: blob || "",
                tShirtInfo: tShirtInfo,
                loading: false,
                size: tShirtInfo.size,
                indexSr: tShirtInfo.indexSr,
                name: tShirtInfo.name,
                number: tShirtInfo.number,
            };

            // REPLACE old thumbnail in localThumbList
            setLocalThumbList((prev) => {
                const existingIndex = prev.findIndex(
                    (item) => parseInt(item.indexSr) === parseInt(pageId)
                );

                if (existingIndex !== -1) {
                    const newList = [...prev];
                    newList[existingIndex] = newItem; // Replace here
                    return newList;
                } else {
                    return [...prev, newItem];
                }
            });
            updateSingleThumbnail(id, pageId, newItem);
        } catch (error) {
            console.error(
                `Error regenerating thumbnail for page ${pageId}:`,
                error
            );

            // Set error state
            const errorItem = {
                base64: "",
                tShirtInfo: tShirtInfo,
                loading: false,
                size: tShirtInfo.size,
                indexSr: tShirtInfo.indexSr,
                name: tShirtInfo.name,
                number: tShirtInfo.number,
            };

            setLocalThumbList((prev) => {
                const existingIndex = prev.findIndex(
                    (item) => parseInt(item.indexSr) === parseInt(pageId)
                );

                if (existingIndex !== -1) {
                    const newList = [...prev];
                    newList[existingIndex] = errorItem;
                    return newList;
                } else {
                    return [...prev, errorItem];
                }
            });
        }
    };

    let exportScale;

    if (selectedFormat === "png") {
    exportScale = +selectedDpi === 72 ? 1 : 2;
    } else {
    exportScale = +selectedDpi === 72 ? 1 : 300 / 72;
    }

    const addCenterLine = async (currPage, size, filename) => {
        try {
            const pageWidth = currPage.width;
            const lineWidth = 5;
            const lineHeight = 10;
            const pageHeight = currPage.height;
            const currPageData = currPage.toJSON();
            const elementIds = [
                `${currPageData.id}-lineElementBlackTop`,
                `${currPageData.id}-lineElementWhiteTop`,
                `${currPageData.id}-lineElementBlackBottom`,
                `${currPageData.id}-lineElementWhiteBottom`,
                `${currPageData.id}-edgeMarking`,
            ];
            const elementsToDelete = currPage.children.filter(
                (child) => !elementIds.includes(child.id)
            );

            currPage.set({
                children: elementsToDelete,
            });

            let lineColor = "#ffffff";

            const imageElement = currPage.children.find(el => el.type === 'image');
            
            if (imageElement?.src) {
                const bgColor = await fac.getColorAsync(imageElement.src);
            
                lineColor = bgColor.isDark ? "#ffffff" : "#000000";
            } else {
                console.log("No image found, defaulting lineColor to white");
            }
            
            // Only add center marking if checked
            if (checkedItems.centerMarking) {
                const lineElementBlackTop = await currPage.addElement({
                    type: "line",
                    x: pageWidth / 2 - lineWidth / 2,
                    y: 0,
                    width: lineWidth,
                    height: lineHeight,
                    name: "lineElementBlackTop",
                    id: `${currPageData.id}-lineElementBlackTop`,
                    color: lineColor,
                });
                const lineElementWhiteTop = await currPage.addElement({
                    type: "line",
                    x: pageWidth / 2 - lineWidth / 2,
                    y: lineHeight,
                    width: lineWidth,
                    height: lineHeight,
                    name: "lineElementWhiteTop",
                    id: `${currPageData.id}-lineElementWhiteTop`,
                    color: "black",
                });
                const lineElementBlackBottom = await currPage.addElement({
                    type: "line",
                    x: pageWidth / 2 - lineWidth / 2,
                    y: pageHeight - lineHeight - lineHeight,
                    width: lineWidth,
                    height: lineHeight,
                    name: "lineElementBlackBottom",
                    id: `${currPageData.id}-lineElementBlackBottom`,
                    color: lineColor,
                });
                const lineElementWhiteBottom = await currPage.addElement({
                    type: "line",
                    x: pageWidth / 2 - lineWidth / 2,
                    y: pageHeight - lineHeight,
                    width: lineWidth,
                    height: lineHeight,
                    name: "lineElementWhiteBottom",
                    id: `${currPageData.id}-lineElementWhiteBottom`,
                    color: "black",
                });
            }

            // Only add size text if checked
            if (checkedItems.edgeMarking) {
                const topLeftSizeDiv = await currPage.addElement({
                    id: filename,
                    type: "text",
                    text: size,
                    // fontFamily: "Arial",
                    // fill: "white",
                    // fontSize: 15,
                    // width: 80,
                    // height: 50,
                    // x: pageWidth / 2 - 120,
                    // y: pageHeight - 50 + 25,

                    fontFamily: "Arial",
                    fill: "white",
                    fontSize: 15,
                    width: 120,
                    height: 50,
                    x: pageWidth / 2 - 120,
                    y: pageHeight - 50 + 25,

                    // backgroundColor: "#ffffff",
                    // backgroundEnabled: true,
                    // backgroundOpacity: 1,
                    stroke: "black",
                    strokeWidth: 2,

                    name: "edgeMarking",
                    id: `${currPageData.id}-edgeMarking`,
                });
            }

            return true;
        } catch (error) {
            console.error("error is", error);
            return false;
        }
    };
    const cancel = () => {
        setShowCancelConfirm(true);
    };
    const confirmCancelDownload = () => {
        cancelPollingRef.current = true;
        setIsPercentDownloading(false);
        setShowDownloadDialog(false);
        setShowCancelConfirm(false);
        dispatch(
            showToast({
                message: "Download cancelled",
                type: "error",
            })
        );
    };

    const rejectCancelDownload = () => {
        setShowCancelConfirm(false);
    };


    const handleDownloadAll = async () => {
        trackAnalyticsEvent("export_download_all_click", {
            format: selectedFormat,
            dpi: selectedDpi,
            variation_count: tshirtDetails?.length || 0,
        });

        if (
            !canUserDownloadImage(
                planDetails,
                tshirtDetails?.length,
                dispatch
            )
        )
            return;


        console.log("plan details ", planDetails, " and tshirt details length ", tshirtDetails?.length);

        // return;



        setIsPercentDownloading(true);
        cancelPollingRef.current = false;
        setShowCancelConfirm(false);
        setPercentDownloaded(0);
        setShowDownloadDialog(true);

        // Clear any previous export jobs
        dispatch(clearExportJobs());

        const getPlayerNameFromPage = (page) => {
            const nameEl = page.children.find(c =>
              c.type === "text" &&
              c.id?.includes("playernametext")
            );
            return nameEl?.text?.trim() || "";
          };
          
          const getPlayerNumberFromPage = (page) => {
            const numEl = page.children.find(c =>
              c.type === "text" &&
              c.id?.includes("playernumbertext")
            );
            return numEl?.text?.trim() || "";
          };

        try {
            const totalPages = store.pages.length;
            const storeFonts = getStoreFonts();
            const preparedPages = [];
            const filenames = [];
            // set fonts
            store.set({
                fonts: designInfo?.store_data?.store_json?.fonts || [],
            });

            const finishFakeProgress = runFakeProgress(setPercentDownloaded);

            for (let i = 0; i < totalPages; i++) {
                const page = store.pages[i];
                const tshirt = tshirtDetails[i] || {};
                let lineCreated = true;
                // let filename = `${tshirt.size || "size"}${tshirt.name ? `_${tshirt.name}` : ""
                //     }${tshirt.number ? `_${tshirt.number}` : ""}_${i + 1
                //     }.${selectedFormat}`;

                    const name   = getPlayerNameFromPage(page);
                    const number = getPlayerNumberFromPage(page);
                    const size   = page?.custom?.size || "size"; // keep if useful

                    // Build filename using live values
                    let filename = `${size}${name ? `_${name}` : ""}${number ? `_${number}` : ""}_${i + 1}.${selectedFormat}`;
                if (
                    selectedType === "a4" ||
                    selectedType === "a3" ||
                    selectedType === "a2" ||
                    selectedType === "a1" ||
                    selectedType === "custom"
                ) {
                    const serial = String(tshirt.indexSr || i + 1).padStart(3, "0");
                    let sizeLabel = selectedType.toUpperCase();
                    // filename = `${tshirt.name ? `_${tshirt.name}` : ""}${tshirt.number ? `${tshirt.number}` : ""
                    //     }.${selectedFormat}`;
                    if (selectedType === "custom") {
                        const width = localStorage.getItem("customWidth") || "000";
                        const height = localStorage.getItem("customHeight") || "000";
                        sizeLabel = `${width}x${height}`;
                    }
                    const namePart = tshirt.name ? `_${tshirt.name.trim()}` : "";
                    const numberPart = tshirt.number ? `_${tshirt.number}` : "";
                    filename = `${serial}_${sizeLabel}${namePart}${numberPart}.${selectedFormat}`;
                }

                if (
                    checkedItems.centerMarking ||
                    checkedItems.edgeMarking
                ) {

                    lineCreated = await addCenterLine(
                        page,
                        selectedType &&
                        (selectedType === "a4" ||
                        selectedType === "a3" ||
                        selectedType === "a2" ||
                        selectedType === "a1" ||
                        selectedType === "custom")
                        ? selectedType === "custom"
                        ? `${localStorage.getItem("customHeight")} x ${localStorage.getItem("customWidth")}`
                        : `${selectedType.toUpperCase()}`
                    : `${page?.custom?.extraData?.sizeNumber} - ${page?.custom?.size}`,
                        filename
                    );


                }

                if (lineCreated) {
                    preparedPages.push(page);
                    filenames.push(filename);
                }
            }

        
                const exportOptions = {
                    format: selectedFormat,
                    dpi: selectedFormat === "pdf" ? 72 : selectedDpi,
                    quality:
                    +selectedDpi === 72
                    ? 1
                    : getQualityForFormat(selectedFormat),
                    pixelRatio: exportScale,
                };
                setPercentDownloaded(10);
        
                const results = await exportBatchFiles(
                store,
                preparedPages,
                exportOptions,
                dispatch,
                null,
                storeFonts
                );

                
                const updatedFilename = filenames.map((name, index) => {
                    const page = preparedPages[index]; 
                    const sizeNumber = page?.custom?.extraData?.sizeNumber;
                    const prefix = sizeNumber ? `${sizeNumber}_` : "";
                    return prefix + name;
                })
        
                if (cancelPollingRef.current) {
                    console.log("Download cancelled by user. Skipping ZIP.");
                    finishFakeProgress();
                    // skip updating variation count - as user has cancelled donwload
                    // await updateVariationCount(totalPages);
                    setIsPercentDownloading(false);
                    setShowDownloadDialog(false);
                    return;
                }
                
                await downloadBatchAsZip(results, updatedFilename, selectedDpi, selectedFormat);
                finishFakeProgress();
                setPercentDownloaded(100);
        
                dispatch(showToast({ message: `All ${selectedFormat} downloaded successfully!`, type:"success" }));
                await updateVariationCount(totalPages);

        } catch (error) {
            console.error("Error during cloud render download:", error);
            dispatch(
                showToast({
                    message: "Error during download: " + error.message,
                    type: "error",
                })
            );
            setIsPercentDownloading(false); 
            setShowDownloadDialog(false);
            setPercentDownloaded(0);
        }
    };
    
    const handleDownload = async (index, item, filename) => {
        trackAnalyticsEvent("export_download_single_click", {
            index,
            file_name: filename,
            format: selectedFormat,
            dpi: selectedDpi,
        });

        let indexSr = item?.indexSr;
        if (
            !canUserDownloadImage(
                planDetails,
                1,
                dispatch
            )
        )
            return;

        try {
            setDownloadCardLoading({
                index,
                loading: true,
            });

            setIsPercentDownloading(true);
            setPercentDownloaded(0);
            setShowDownloadDialog(true);

            const finishFakeProgress = runFakeProgress(setPercentDownloaded);


            const found = store.pages.find((page) => parseInt(page?.id) === parseInt(indexSr));

            if (!found) {
                throw new Error("Image not found");
            }

            // Add center line if needed
            let lineCreated = true;

            lineCreated = await addCenterLine(
                found,
                selectedType &&
                    (selectedType === "a4" ||
                    selectedType === "a3" ||
                    selectedType === "a2" ||
                    selectedType === "a1" ||
                    selectedType === "custom")
                    ? selectedType === "custom"
                    ? `${localStorage.getItem("customHeight")} x ${localStorage.getItem("customWidth")}`
                    : `${selectedType.toUpperCase()}`
                : `${item?.tShirtInfo?.extraData?.sizeNumber} - ${item?.size}`,
                filename
            );

            
            // }
            if (lineCreated) {
                // Use cloud render for export
                // const exportOptions = {
                //     format: selectedFormat,
                //     dpi: selectedDpi,
                //     quality:
                //         +selectedDpi === 72
                //             ? 1
                //             : getQualityForFormat(selectedFormat),
                //     pixelRatio: exportScale,
                //     filename: filename,
                // };

                const exportOptions = {
                    format: selectedFormat,
                    dpi: selectedFormat === "pdf" ? 72 : selectedDpi,
                    quality:
                        +selectedDpi === 72
                            ? 1
                            : getQualityForFormat(selectedFormat),
                    pixelRatio: exportScale,
                    filename: filename,
                };

                // Validate options
                validateExportOptions(exportOptions);

                // Export using cloud render

                const storeFonts = getStoreFonts();

                store.set({
                    fonts: storeFonts || [],
                });

                await exportSingleFile(
                    store,
                    found.id,
                    exportOptions,
                    dispatch,
                    storeFonts
                );

                finishFakeProgress();

                // Update variation count
                updateVariationCount(1);

                dispatch(
                    showToast({
                        message: "File downloaded successfully",
                        type: "success",
                    })
                );
            } else {
                dispatch(
                    showToast({
                        message: "Error in creating center image",
                        type: "error",
                    })
                );
            }
        } catch (error) {
            console.error("Error in handleDownload:", error);
            dispatch(
                showToast({
                    message: "Error downloading file: " + error.message,
                    type: "error",
                })
            );
        } finally {
            setDownloadCardLoading({
                index,
                loading: false,
            });
        }
    };

    const updateVariationCount = async (count) => {
        try {
            let obj = {
                variation_count: count ? count : "1",
            };
            window.gtag("event", "Variation Downloaded", obj);
        } catch (error) { }

        if (!planDetails || !planDetails.plan_id) {
            toast.info("Please choose a plan first");
            navigate("/plans");
            return;
        }
        let user = JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS));
        let data = {
            id: user?.user_plan_id,
            count: count ? count.toString() : "1",
            user_id: user?.id,
        };
        try {
            let response = await doRequest(data, "POST", "plan/add-variant ");
            if (+response?.resultFlag === 1) {
                localStorage.removeItem(config.USER_PLAN_DETAILS);
                let plan = response?.response?.userPlan;
                let variants = response?.response?.variants;
                localStorage.setItem(
                    config.USER_PLAN_DETAILS,
                    JSON.stringify(plan)
                );
                localStorage.setItem(
                    config.VARIANT_COUNT,
                    JSON.stringify(variants)
                );
                // await getUserData();
                dispatch(getPlanDetails());
            } else {
                console.error(response?.message);
            }
        } catch (error) {
            console.error(
                error.message ? error?.message : "Something went wrong"
            );
        }
    };

    const getUserData = async () => {
        try {
            let email = "";
            const localDetails = localStorage.getItem(
                config.USER_LOGIN_DETAILS
            );
            if (localDetails) {
                email = JSON.parse(localDetails)?.email;
            }

            const data = {
                email,
            };
            const response = await doRequest(data, "POST", "user/data");
            if (response?.resultFlag == 1) {
                dispatch(setUserData({ userData: response?.response?.user }));
                dispatch(
                    setAllData({
                        userPlanDetails: response?.response?.userPlan,
                        variants: response?.response?.variants,
                    })
                );
            }
        } catch (error) {
            console.error("user data api error is", error);
        }
    };

    // Function to call Polotno Cloud Render API
    const handlePolotnoCloudRender = async () => {
        try {
            const designJson = store.toJSON();
            await dispatch(renderPolotnoDesign(designJson));
            toast.success("Polotno Cloud render job submitted!");
        } catch (err) {
            dispatch(
                showToast({
                    message: "Failed to submit render job",
                    type: "error",
                })
            );
            // toast.error("Failed to submit render job");
        }
    };

    const handleClickOutside = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
        ) {
            setPreferenceType(false);
        }
    };

    const handleSaveSettings = async () => {
        trackAnalyticsEvent("export_save_settings_click", {
            format: selectedFormat,
            dpi: selectedDpi,
            center_marking: checkedItems.centerMarking,
            size_on_bottom: checkedItems.edgeMarking,
        });

        try {
            setSaveSettingsLoading(true);

            const payload = {
                export_settings: {
                    centerMarking: checkedItems.centerMarking,
                    sizeOnBottom: checkedItems.edgeMarking,
                    downloadType: selectedFormat,
                    downloadDpi: parseInt(selectedDpi),
                },
            };

            const response = await doRequest(
                payload,
                "POST",
                "user/export-settings"
            );

            if (response?.resultFlag === 1) {
                dispatch(
                    showToast({
                        message: "Export settings saved successfully!",
                        type: "success",
                    })
                );
                setPreferenceType(false); // Hide the popup
            } else {
                dispatch(
                    showToast({
                        message:
                            response?.message ||
                            "Failed to save export settings",
                        type: "error",
                    })
                );
            }
        } catch (error) {
            console.error("Error saving export settings:", error);
            dispatch(
                showToast({
                    message: "Error saving export settings: " + error.message,
                    type: "error",
                })
            );
        } finally {
            setSaveSettingsLoading(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (userExportSettings) {
            setSelectedFormat(userExportSettings?.downloadType);
            setSelectedDpi(userExportSettings?.downloadDpi);
            setCheckedItems((prev) => {
                return {
                    ...prev,
                    centerMarking: userExportSettings?.centerMarking,
                    edgeMarking: userExportSettings?.sizeOnBottom,
                };
            });
        }
    }, [userExportSettings]);

    return (
        <>

            {showWarnPopup && (
                <div className="success_bg">
                    <div
                        className="success_content"
                        style={{ maxWidth: "615px" }}
                    >
                        <div className="row">
                            <div className="justify-content-center text-center">
                                <h2>
                                    Image downloading in progress, please don't
                                    switch tabs
                                </h2>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="justify-content-center text-center">
                                <Button
                                    color="create_variations mb-3 ms-3"
                                    onClick={() => {
                                        setShowWarnPopup(false);
                                    }}
                                >
                                    Okay
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div id="main-container" className="container-fluid main">
                <div className="left-main-menu">
                    <Sidebar />
                </div>

                <div className="export-main">
                    <div className="artboard--main__header">
                        <div className="export--main__header--left--back">
                            <BackButton
                                onClick={() => navigate(`/variation/${id}`)}
                            />
                            <VariationCountLabel
                                userPlanDetails={userPlanDetails}
                            />
                            <InternetSpeedIndicator />
                        </div>
                        <div className="artboard--main__header--center">
                            <div className="artboard--main__tabs">
                                <Link
                                    to={`/Design/${id}`}
                                    onClick={() => {
                                        if (
                                            isPercentDownloading &&
                                            +percentDownloaded !== 100
                                        ) {
                                            setShowWarnPopup(true);
                                        } else {
                                            window.location.href = `/Design/${id}`;
                                        }
                                    }}
                                    className="artboard--main__tabs--nav__item"
                                >
                                    Design
                                </Link>
                                <Link
                                    to={`/variation/${id}`}
                                    className="artboard--main__tabs--nav__item"
                                    onClick={() => {
                                        if (
                                            isPercentDownloading &&
                                            +percentDownloaded !== 100
                                        ) {
                                            setShowWarnPopup(true);
                                        } else {
                                            window.location.href = `/variation/${id}`;
                                        }
                                    }}
                                >
                                    Variation
                                </Link>
                                <Link
                                    to={`/export/${id}`}
                                    className="artboard--main__tabs--nav__item active"
                                >
                                    Export
                                </Link>
                            </div>
                        </div>
                        <div className="artboard--main__header--right">
                            {/* New Code needs to be uncomment before */}
                            <div ref={dropdownRef}>
                                <div
                                    className={`preferences-options ${preferenceType ? "open" : ""
                                        }`}
                                >
                                    <div
                                        className="preferences-button"
                                        onClick={() => {
                                            const willOpen = !preferenceType;
                                            trackAnalyticsEvent("export_settings_popover_toggle", {
                                                open: willOpen,
                                            });
                                            setPreferenceType(willOpen);
                                        }}
                                    >
                                        <Settings
                                            size={12}
                                            style={{ marginRight: ".25rem" }}
                                        />

                                        <span
                                            style={{
                                                display: "flex",
                                                gap: ".125rem",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedFormat}
                                            <b>·</b>
                                            {selectedDpi}

                                            {checkedItems.centerMarking ? (
                                                <>
                                                    {" "}
                                                    <b>·</b>
                                                    {"CM"}
                                                </>
                                            ) : (
                                                ""
                                            )}
                                            {checkedItems.edgeMarking ? (
                                                <>
                                                    <b>·</b>
                                                    {"S"}
                                                </>
                                            ) : (
                                                ""
                                            )}
                                        </span>

                                        <ChevronDown
                                            size={14}
                                            style={{
                                                marginLeft: ".25rem",
                                                transform: preferenceType
                                                    ? "rotate(180deg)"
                                                    : "",
                                            }}
                                            strokeWidth={3}
                                        />
                                    </div>



                                    <div className="preferences-options__popup">
                                        <h4>Select File Type</h4>

                                        {/* FILE TYPE DROPDOWN */}
                                        <div
                                            className={`filetype-selector ${openDropdown === "format" ? "open" : ""}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenDropdown(openDropdown === "format" ? null : "format");
                                            }}
                                        >
                                            <div className="filetype-selector__header">
                                                <h5 className="filetype-selector__title">
                                                    <Image size={14} style={{ marginRight: ".5rem" }} />
                                                    {selectedFormat ? selectedFormat : "File Type"}

                                                    <ChevronDown
                                                        size={14}
                                                        style={{
                                                            marginLeft: "auto",
                                                            transform: openDropdown === "format" ? "rotate(180deg)" : "",
                                                        }}
                                                        strokeWidth={3}
                                                    />
                                                </h5>
                                            </div>

                                            <div className="filetype-selector__options">
                                                {allFormats?.map((format) => (
                                                    <div
                                                        key={format.type}
                                                        className={`filetype-option ${
                                                            format.type === selectedFormat ? "active" : ""
                                                        }`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            trackAnalyticsEvent("export_format_change", {
                                                                format: format.type,
                                                            });
                                                            setSelectedFormat(format.type);
                                                            setOpenDropdown(null);
                                                        }}
                                                    >
                                                        <Image size={12} style={{ marginRight: ".5rem" }} />
                                                        {format.type}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* DPI DROPDOWN */}
                                        <div
                                            className={`filetype-selector ${openDropdown === "dpi" ? "open" : ""}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenDropdown(openDropdown === "dpi" ? null : "dpi");
                                            }}
                                            style={{ marginTop: "20px" }}
                                        >
                                            <div className="filetype-selector__header">
                                                <h5 className="filetype-selector__title">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={24}
                                                        height={24}
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <g>
                                                            <rect width={24} height={24} fill="none" />
                                                        </g>
                                                        <g>
                                                            <path
                                                                d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                                                fill="#0d214b"
                                                            />
                                                            <path
                                                                d="M12,6a6,6,0,1,0,6,6A6,6,0,0,0,12,6Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"
                                                                fill="#0d214b"
                                                            />
                                                        </g>
                                                    </svg>

                                                    {selectedDpi ? `${selectedDpi} DPI` : "DPI"}

                                                    <ChevronDown
                                                        size={14}
                                                        style={{
                                                            marginLeft: "auto",
                                                            transform: openDropdown === "dpi" ? "rotate(180deg)" : "",
                                                        }}
                                                        strokeWidth={3}
                                                    />
                                                </h5>
                                            </div>

                                            <div className="filetype-selector__options">
                                                {dpis?.map((dpi) => (
                                                    <div
                                                        key={dpi.type}
                                                        className={`filetype-option ${
                                                            dpi.type === selectedDpi ? "active" : ""
                                                        }`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            trackAnalyticsEvent("export_dpi_change", {
                                                                dpi: dpi.type,
                                                            });
                                                            setSelectedDpi(dpi.type);
                                                            setOpenDropdown(null);
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            style={{
                                                                width: 12,
                                                                height: 12,
                                                                marginRight: ".5rem",
                                                            }}
                                                        >
                                                            <g>
                                                                <rect width={24} height={24} fill="none" />
                                                            </g>
                                                            <g>
                                                                <path
                                                                    d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                                                    fill="#0d214b"
                                                                />
                                                                <path
                                                                    d="M12,6a6,6,0,1,0,6,6A6,6,0,0,0,12,6Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"
                                                                    fill="#0d214b"
                                                                />
                                                            </g>
                                                        </svg>
                                                        {dpi.text}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* CHECKBOX OPTIONS */}
                                        <div className="preferences-options">
                                            {options.map((option) => (
                                                <div
                                                    key={option.name}
                                                    className="preferences-options__marking"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <label
                                                        className={
                                                            checkedItems[option.name] ? "active" : ""
                                                        }
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={!!checkedItems[option.name]}
                                                            onChange={() =>
                                                                handleCheckboxChange(option.name)
                                                            }
                                                        />
                                                        <span>{option.label}</span>
                                                        <img
                                                            src={option.img}
                                                            alt={`${option.label} icon`}
                                                        />
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                        <button
                                            onClick={handleSaveSettings}
                                            disabled={saveSettingsLoading}
                                            className="preferences-options__button"
                                        >
                                            {saveSettingsLoading ? (
                                                <BeatLoader color="#ffffff" size={8} />
                                            ) : (
                                                "Save Settings"
                                            )}
                                        </button>
                                    </div>

                                </div>
                            </div>

                            {showDownloadDialog && (
                                <DownloadCancelPopup
                                    percentDownloaded={percentDownloaded}
                                    close={() => {
                                        setIsPercentDownloading(false);
                                        setShowDownloadDialog(false);
                                    }}
                                    cancel={cancel}
                                    onConfirmCancel={confirmCancelDownload}
                                    onRejectCancel={rejectCancelDownload}
                                    showCancelConfirm={showCancelConfirm}
                                />
                            )}
                            <button
                                disabled={
                                    loading ||
                                    showCancelConfirm ||
                                    showDownloadDialog || 
                                    isPlanExpired(planDetails)
                                }
                                onClick={handleDownloadAll}
                                type="button"
                                className="primary-button"
                            >
                                <Download size={16} style={{ marginRight: "8px" }} />
                                Download All
                            </button>
                        </div>
                    </div>
                    <div className="artboard--main">
                        <div className="artboard--main__top">
                            <div className="artboard--main__top--numbers">
                                <h4>{designInfo?.size_data?.sizes?.length}</h4>{" "}
                                Variations created
                            </div>
                            <div class="artboard--main__export--search">
                                <div class="search-block">
                                    {/* <Search size={14} /> */}
                                    <input
                                        type="text"
                                        placeholder={"Search all files"}
                                        onChange={(e) =>
                                            setSearchQuery(e.target.value)
                                        }
                                        value={searchQuery}
                                        style={{
                                            paddingRight: searchQuery
                                                ? "40px"
                                                : "12px",
                                            fontSize: "12px",
                                        }}
                                    />
                                    {searchQuery && (
                                        <button
                                            onClick={() => setSearchQuery("")}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                padding: "5px 0",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <X size={14} />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        
                        <div className="artboard--main__export">
                            <div className="artboard--main__export--search">
                                <Workspace store={store} />
                            </div>
                            {errorMessage && filteredThumbList.length === 0 && !loading ? (
                                <ErrorMessage message={errorMessage} />
                            ) : null}

                            <div className="artboard--main__export--teeshirts">
                                {loading && filteredThumbList.length === 0 ? (
                                    <LoadingMessage />
                                ) : searchQuery &&
                                    filteredThumbList.length === 0 ? (
                                    <div
                                        className="no-results"
                                        style={{
                                            textAlign: "center",
                                            padding: "40px",
                                            width: "100%",
                                        }}
                                    >
                                        <SearchX
                                            size={64}
                                            color="#dc3545"
                                            strokeWidth={1.5}
                                        />
                                        <p
                                            style={{
                                                color: "#dc3545",
                                                fontSize: "16px",
                                                marginTop: "20px",
                                            }}
                                        >
                                            No thumbnails found matching "
                                            <strong>{searchQuery}</strong>"
                                        </p>
                                    </div>
                                ) : (
                                    filteredThumbList?.map((item, index) => {
                                        const prefix = item?.tShirtInfo?.extraData?.sizeNumber ? `${item?.tShirtInfo?.extraData?.sizeNumber}-` : ''
                                        let filename = `${prefix}${item?.size}${item?.name ? `_${item?.name}` : ""
                                            }${item?.number
                                                ? `_${item?.number}`
                                                : ""
                                            }.${selectedFormat}`;

                                        if (
                                            selectedType === "a4" ||
                                            selectedType === "a3" ||
                                            selectedType === "a2" ||
                                            selectedType === "a1" ||
                                            selectedType === "custom"
                                        ) {
                                            filename = `${prefix}${item?.name
                                                    ? `${item?.name}`
                                                    : ""
                                                }${item?.number
                                                    ? `_${item?.number}`
                                                    : ""
                                                }.${selectedFormat}`;
                                        }
                                        
                                        return item.loading ? (
                                            <div
                                                className="skeleton--main__export--teeshirts--item"
                                                style={{
                                                    width: "calc((100% / 6) - 1.563vw)",
                                                    padding: "10px",
                                                    marginRight: "20px",
                                                    maxHeight: "200px",
                                                }}
                                            >
                                                <Skeleton />
                                            </div>
                                        ) : (
                                            <ThumbnailCard
                                                key={filename + "_" + index}
                                                item={item}
                                                filename={filename}
                                                index={index}
                                                downloadCardLoading={
                                                    downloadCardLoading
                                                }
                                                isPercentDownloading={
                                                    isPercentDownloading
                                                }
                                                isEdit={isEdit}
                                                loading={loading}
                                                navigate={navigate}
                                                handleDownload={handleDownload}
                                                store={store}
                                                id={id}
                                                planDetails={planDetails}
                                            />
                                        );
                                    })
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Button to trigger Polotno Cloud Render API */}
            <button
                onClick={handlePolotnoCloudRender}
                disabled={renderLoading}
                style={{ marginBottom: 16 }}
            >
                {renderLoading ? "Rendering..." : "Render on Polotno Cloud"}
            </button>
            {/* Show render job response for debugging */}
            {renderJob && (
                <pre
                    style={{
                        background: "#f5f5f5",
                        padding: 8,
                        borderRadius: 4,
                        marginBottom: 16,
                    }}
                >
                    {JSON.stringify(renderJob, null, 2)}
                </pre>
            )}
            {renderError && (
                <div style={{ color: "red", marginBottom: 16 }}>
                    Error: {renderError}
                </div>
            )}
        </>
    );
}
